module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "section white"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-12 col-md-10 col-md-offset-1 col-lg-8 col-lg-offset-2"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "clear-sm"
  }), _vm._v(" "), _c('form', {
    staticClass: "form"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.nombre),
      expression: "formData.nombre"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.nombre)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.nombre = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.formData.nombre.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Campo requerido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Apellido")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.apellido),
      expression: "formData.apellido"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.apellido)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.apellido = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.formData.apellido.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Campo requerido")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Nombre de tu empresa")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.nombreEmpresa),
      expression: "formData.nombreEmpresa"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.nombreEmpresa)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.nombreEmpresa = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.formData.nombreEmpresa.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Campo requerido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Barrio o Zona")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.barrio),
      expression: "formData.barrio"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.barrio)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.barrio = $event.target.value
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("E-Mail")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.email),
      expression: "formData.email"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "mail"
    },
    domProps: {
      "value": (_vm.formData.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.email = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.formData.email.email && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Campo requerido")]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Teléfono")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.telefono),
      expression: "formData.telefono"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "text"
    },
    domProps: {
      "value": (_vm.formData.telefono)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.telefono = $event.target.value
      }
    }
  })])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 col-sm-12 "
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', {
    attrs: {
      "for": ""
    }
  }, [_vm._v("Mensaje")]), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.formData.mensaje),
      expression: "formData.mensaje"
    }],
    staticClass: "form-control",
    attrs: {
      "rows": "7"
    },
    domProps: {
      "value": (_vm.formData.mensaje)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.formData.mensaje = $event.target.value
      }
    }
  }), _vm._v(" "), (!_vm.$v.formData.mensaje.required && _vm.mostrarErrores) ? _c('span', {
    staticClass: "label label-danger"
  }, [_vm._v("Campo requerido")]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "row text-center center-block"
  }, [_c('vue-recaptcha', {
    attrs: {
      "sitekey": "6LfZAikUAAAAAOU_SNuSQG_-dF2mOiHV4XHqrpaF"
    },
    on: {
      "verify": _vm.onVerify
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-action text-center"
  }, [_c('button', {
    staticClass: "btn btn-fill btn-lg size-16",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.clickEnviar($event)
      }
    }
  }, [_vm._v("ENVIAR")])])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-text margin-top-60"
  }, [_c('h1', {
    staticClass: "lato size-34 margin-bottom-40 txt-black"
  }, [_vm._v("Contacta con andalepide")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "row contact-info"
  }, [_c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box-text"
  }, [_c('h1', {
    staticClass: "lato txt-green size-24 regular"
  }, [_vm._v("Cliente")]), _vm._v(" "), _c('p', {
    staticClass: "size-16 margin-bottom-20"
  }, [_vm._v("¿Deseás contratar nuestros servicios para los almuerzos de tus empleados?")])]), _vm._v(" "), _c('div', {
    staticClass: "box-text"
  }, [_c('span', {
    staticClass: "line2"
  }), _vm._v(" "), _c('p', {
    staticClass: "size-18 no-margin"
  }, [_vm._v("info@andalepide.com")]), _vm._v(" "), _c('p', {
    staticClass: "size-18"
  }, [_vm._v("+54 351 250 3773")]), _vm._v(" "), _c('p', {
    staticClass: "size-18"
  }, [_vm._v("+54 351 771 8029")])])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-6 col-sm-6 col-md-6 col-lg-6"
  }, [_c('div', {
    staticClass: "box-text"
  }, [_c('h1', {
    staticClass: "lato txt-green size-24 regular"
  }, [_vm._v("Proveedor")]), _vm._v(" "), _c('p', {
    staticClass: "size-16 margin-bottom-20"
  }, [_vm._v("¿Querés vender tus comidas a través de Andalepide?")])]), _vm._v(" "), _c('div', {
    staticClass: "box-text"
  }, [_c('span', {
    staticClass: "line2"
  }), _vm._v(" "), _c('p', {
    staticClass: "size-18 no-margin"
  }, [_vm._v("info@andalepide.com")]), _vm._v(" "), _c('p', {
    staticClass: "size-18"
  }, [_vm._v("+54 351 250 3773")]), _vm._v(" "), _c('p', {
    staticClass: "size-18"
  }, [_vm._v("+54 351 771 8029")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f2fdb7b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/static/Contacto.vue
// module id = 1171
// module chunks = 5